"use client";

import { jsxs as n, jsx as t } from "react/jsx-runtime";
import { useRef as j, useState as z, useEffect as C } from "react";
import { classNames as i } from "../../utilities/index.js";
import F from "../Label/index.js";
const L = _ref => {
    let {
      id: r,
      labelText: m,
      hideLabel: d,
      required: u,
      className: b,
      groupClass: f,
      assistiveText: o,
      error: s,
      errorText: x,
      helpText: e,
      tooltipContent: l,
      tooltipPosition: h = "bottom",
      rows: v = 4,
      ...w
    } = _ref;
    const a = j(null),
      [g, p] = z(!1),
      y = i({
        "sash-FormGroup relative mb-4": !0,
        [f]: f
      }),
      $ = i({
        "sash-TextArea font-semibold block border bg-white text-black w-full p-3 resize-none text-base disabled:border-gray-60 disabled:bg-gray-3 focus:outline-none focus:border-blue focus:ring-1": !0,
        "border-black": !s,
        "border-red": s,
        [b]: b
      }),
      A = i({
        "sash-InputTooltip absolute bg-white p-2 border border-black z-2 text-caption shadow-md right-0 max-w-[40ch] w-fit": !0,
        "bottom-full": h === "top",
        "top-full": h === "bottom"
      });
    C(() => {
      if (!(!l || !e)) return document.addEventListener("click", k), () => document.removeEventListener("click", k);
    }, [l, e]);
    const E = c => {
        c.preventDefault(), p(!g);
      },
      k = c => {
        var N;
        a != null && a.current && !((N = a.current) != null && N.contains(c.target)) && p(!1);
      };
    return /* @__PURE__ */n("div", {
      ref: a,
      className: y,
      children: [(m || e) && /* @__PURE__ */n("div", {
        className: `relative flex items-center ${!o && (!d || e) ? "mb-1" : ""}`,
        children: [/* @__PURE__ */t(F, {
          htmlFor: r,
          className: `flex-1 ${u ? "text-required" : ""}`,
          hide: d,
          error: s,
          children: m
        }), e && /* @__PURE__ */t("button", {
          className: "ml-auto flex-none text-xs leading-tight text-blue hover:underline",
          onClick: E,
          children: e
        }), g && l && /* @__PURE__ */t("div", {
          className: A,
          children: l
        })]
      }), o && /* @__PURE__ */t("p", {
        className: `mb-1 mt-px text-xs leading-tight ${s ? "text-red" : "text-gray-60"}`,
        children: o
      }), /* @__PURE__ */t("textarea", {
        id: r,
        name: r,
        className: $,
        required: u,
        rows: v,
        ...w
      }), s && x && /* @__PURE__ */n("p", {
        "aria-describedby": r,
        className: "flex items-center text-xs text-red",
        children: [/* @__PURE__ */t("span", {
          className: "material-symbols-sharp mr-1 text-base",
          children: "warning"
        }), x]
      })]
    });
  },
  I = L;
export { I as default };